module.exports = __webpack_public_path__ + "img/bg.e4134f09.jpg";